module.exports = __webpack_public_path__ + "static/media/loading_test.e96d2a0f.svg";